import { useCallback } from 'react';
import { useSessionOrNull } from '~/contexts/SessionContext';
import type { OpenIntent } from './resolveOpenIntent';
import { useCloseAndOpenPatient } from './useCloseAndOpenPatient';

/**
 * Re-opens the loaded connector patient from the database, as the given
 * intent or as the whole patient. Does nothing when no connector patient is
 * loaded.
 *
 * Unsaved changes are discarded with the unload; a caller asks first.
 */
export function useReopenPatient(): (intent?: OpenIntent) => void {
    const session = useSessionOrNull();
    const closeAndOpen = useCloseAndOpenPatient();

    return useCallback(
        (intent?: OpenIntent): void => {
            const patientId =
                session?.persistenceRegistry.patientRef?.patientId;
            if (!patientId) {
                return;
            }
            closeAndOpen(patientId, intent);
        },
        [session, closeAndOpen]
    );
}
